// extracted by mini-css-extract-plugin
module.exports = {"reactMarkDown":"markdown_reactMarkDown__2cK21","container":"markdown_container__gOyHy","updateCard":"markdown_updateCard__2d2Iq"};